import axios from '#/plugins/Axios.js'

const localHosts = ['localhost', 'lvh.me', '.dev', '.intra']
const host = window.location.host
let isLocalEnv = false
for (let i = 0; i <= localHosts.length; i++) {
  if (host.endsWith(localHosts[i])) {
    isLocalEnv = true
    break
  }
}

let apiUrl = 'https://kp.youniversal.com'
if (isLocalEnv) {
  apiUrl = 'https://kp.lvh.me'
} else if (host.includes('staging')) {
  apiUrl = 'https://kp-staging.youniversal.com'
}

class URL {
  constructor(base) {
    this.base = base + '/api/v1'
  }

  path(path, args) {
    path = path.split('.')
    let obj = this,
      url = this.base

    for (let i = 0; i < path.length && obj; i++) {
      if (obj.url) {
        url += '/' + obj.url
      }

      obj = obj[path[i]]
    }
    if (obj) {
      url = url + '/' + (typeof obj === 'string' ? obj : obj.url)
    }

    if (args) {
      for (let key in args) {
        url = url.replace(':' + key, args[key])
      }
    }

    return url
  }

  get(path, args) {
    return axios.get(this.path(path, args))
  }

}

export const api = Object.assign(new URL(apiUrl), {
  url: '',

  config: {
    url: 'config/spa'
  },

  login: {
    url: 'login'
    //refresh: 'refresh'
  },

  checkUser: {
    url: 'check-user'
  },

  setup: {
    url: 'setup'
  },

  me: 'me',

  profile: {
    url: 'profile'
  }

})
